import { Upload } from "lucide-react";
import { useState } from "react";

import api, { formatApiError } from "../lib/api";

export default function MediaUploader({ accept, kind, onUploaded, successMessage = "Lastet opp. Husk å lagre innholdet.", testId }) {
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState("");
  const [uploading, setUploading] = useState(false);

  const upload = async () => {
    if (!file) return;
    setUploading(true);
    setStatus("");
    const data = new FormData();
    data.append("file", file);
    try {
      const response = await api.post(`/admin/media?kind=${kind}`, data);
      onUploaded(response.data.url);
      setStatus(successMessage);
    } catch (error) {
      setStatus(formatApiError(error));
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="media-uploader" data-testid={`${testId}-uploader`}>
      <input
        accept={accept}
        data-testid={`${testId}-file-input`}
        onChange={(event) => setFile(event.target.files?.[0] || null)}
        type="file"
      />
      <div className="media-uploader__actions">
        <span data-testid={`${testId}-file-name`}>{file?.name || "Velg fil fra enhet"}</span>
        <button data-testid={`${testId}-upload-button`} disabled={!file || uploading} onClick={upload} type="button">
          <Upload size={15} />
          {uploading ? "Laster opp..." : "Last opp"}
        </button>
      </div>
      {status && <small data-testid={`${testId}-upload-status`}>{status}</small>}
    </div>
  );
}